import React from "react";
import { useSelector } from "react-redux";
import { rootReducer } from "../store/store";
import { useEffect, useState, useRef } from "react";
import axiosInstance from "../api/axiosInstance";
import { AxiosResponse } from "axios";
import { CarInsuranceChargeInfo, CarInsuranceInfo } from "../types/CarInsuranceChargeTypes";
import SvgIcon from "@mui/material/SvgIcon";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import "./scss/product.scss";
import { useCommonUtil } from "../util/useCommonUtil";
import { AlertType, alertType } from "../types/CommonType";
import AlertModal from "../components/AlertModal";

type AuthState = ReturnType<typeof rootReducer>;

interface AddCarInsuranceProps {
    handleInsRadioChange: (event: React.ChangeEvent<HTMLInputElement>, item: CarInsuranceChargeInfo, chargeRequester: number) => void
    noSelectInsItem: () => void
}

const AddCarInsurance: React.FC<AddCarInsuranceProps> = (
    {handleInsRadioChange, noSelectInsItem}
) => {
    const {
        formatNumber
    } = useCommonUtil();
    const [insArray, setInsArray] = useState<Array<CarInsuranceInfo>>([]);
    const resInfo = useSelector((state: AuthState) => state.store.resOneInfo);
    const scrollContainerRef2 = useRef<HTMLDivElement>(null);
    const [selectedCarInsuranceId, setSelectedCarInsuranceId] = useState(0);

    const noSelectCarInsurance = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        if(event.target.checked) {
            setSelectedCarInsuranceId(0);
            noSelectInsItem();
        }
    }
  const [alertInfo, setAlertInfo] = useState<AlertType>(alertType);
    const selectCarInsurance = (
        event: React.ChangeEvent<HTMLInputElement>,
        item: CarInsuranceInfo
    ) => {
        console.log(item);
        if(event.target.checked) {
            const filteredItem: CarInsuranceChargeInfo = {
                insuranceId: item.insuranceId,
                chargeRequester: item.chargeValue, // 실제 금액을 고객납부금으로 처리
                insuranceName: item.insuranceName,
                chargeBase: item.chargeBase,
                chargeValue: item.chargeValue,
                chargeCustomer: 0, // 키오스크에서 선택하는 경우, 고객납부금으로 처리
                reservationId: item.reservationId,
                companyId: item.companyId,
                carInsuranceInfo: item.carInsuranceInfo,
            };

            setSelectedCarInsuranceId(item.insuranceId);
            handleInsRadioChange(event, filteredItem, filteredItem.chargeRequester);
        }
    }

    const addLineBreaks = (text: string) => {
        return text.split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ));
    };

    const getInsuranceList = async () => {
        try{
            const req = {
                companyId: resInfo?.data?.companyId,
                customerId: resInfo?.data?.customerId,
                modelId: resInfo?.data?.modelId,
                takeoverDtm: resInfo?.data?.takeOverStrDtm,
                returnDtm: resInfo?.data?.returnStrDtm
            }

            await axiosInstance().post('/kiosk/selectCarInsurance.do', req).then((res: AxiosResponse<CarInsuranceInfo>) => {
                setInsArray(res.data.list.filter(ins => ins.carInsuranceInfo.insuranceType !== '4000'));
            })
        } catch(error){
            console.log(error);

            setAlertInfo({
                show: true,
                title: "키오스크 시스템 에러",
                content: "에러가 발생했습니다.<br/>다시 시도해주세요.",
                callback: () => window.location.reload()
            });
        }
    }

    useEffect(() => {
        getInsuranceList();
    }, []);

    return (
        <>
            {alertInfo.show && (
                <AlertModal
                onClose={() => {
                    setAlertInfo(prev => ({ ...prev, show: false }))
                }}
                title={alertInfo.title}
                content={alertInfo.content}
                ></AlertModal>
            )}
            <div className="product-title-wrap">자차보험 추가하기</div>
            <div className="add-ins-wrap">
                <div className="title">
                    <span>자차보험</span>
                    <div className="icon-wrap">
                        <SvgIcon
                            component={ErrorOutlineOutlinedIcon}
                            style={{ marginRight: "5px" }}
                        ></SvgIcon>
                        <span>중복 선택 불가</span>
                    </div>
                </div>
          </div>
          <div
            className="add-ins-product-wrap"
            ref={scrollContainerRef2}
            id="add-ins-product-wrap"
          >
            {insArray && insArray.length > 0 ? (
            <>
                {insArray.map((item: CarInsuranceInfo, idx: number) => (
                <label key={idx}>
                    <div className="product-list" style={{ alignItems: "center" }}>
                        <div style={{ width: "45px" }}>
                            <div className="nm-radio">
                                <input
                                    type="radio"
                                    value={item.insuranceId}
                                    checked={selectedCarInsuranceId === item.insuranceId}
                                    onChange={(event) => {
                                        selectCarInsurance(event, item);
                                    }}
                                >
                                </input>
                                <span className="radio"></span>
                            </div>
                        </div>
                        <div className="product-name">
                            <span style={{ marginBottom: "7px" }}>
                                {item.insuranceName}
                            </span>
                            <span className="etc">
                                {addLineBreaks(item.carInsuranceInfo.content || '')}
                            </span>
                        </div>
                        <div className="product-price-wrap">
                            <span>{formatNumber(item.chargeValue)}원</span>
                        </div>
                    </div>
                </label>
                ))}
                <label>
                    <div className="product-list" style={{ alignItems: "center" }}>
                        <div style={{ width: "45px" }}>
                            <div className="nm-radio">
                                <input
                                    type="radio"
                                    value={0}
                                    checked={selectedCarInsuranceId === 0}
                                    onChange={(event) => {
                                        noSelectCarInsurance(event);
                                    }}
                                ></input>
                                <span className="radio"></span>
                            </div>
                        </div>
                        <div className="product-name">
                            <span style={{ marginBottom: "7px" }}>
                                선택 없음
                            </span>
                            <span className="etc"></span>
                        </div>
                        <div className="product-price-wrap">
                            <span>{formatNumber(0)}원</span>
                        </div>
                    </div>
                </label>
            </>
            ) : (
                <p style={{ fontSize: "1.5em" }}>등록된 자차보험 상품이 없습니다.</p>
            )}
          </div>
        </>
    );
}

export default AddCarInsurance;